import type { UserRow } from './UsersTable'

/**
 * Fonte única do rótulo/cor de status Kanidm de um usuário (C8 UX-B1).
 * Antes duplicado em UsersTable, UserDrawer e (a lógica de filtro) Usuarios.
 */
export function getKanidmLabel(user: Pick<UserRow, 'must_change_password' | 'ldap_synced'>): string {
  if (user.must_change_password) return 'Aguardando troca de senha'
  if (user.ldap_synced === true) return 'Kanidm sincronizado'
  // `ldap_synced: null` = o backend não conseguiu falar com o Kanidm nesta
  // requisição (users_list degrada para None). Não é "pendente" — dizer
  // "pendente" fazia a tela afirmar que TODO mundo estava fora do diretório
  // durante uma indisponibilidade, e o botão de re-sync (só para `=== false`)
  // desaparecia junto.
  if (user.ldap_synced == null) return 'Status Kanidm indisponível'
  return 'Kanidm pendente'
}

export function getKanidmColor(user: Pick<UserRow, 'must_change_password' | 'ldap_synced'>): string {
  if (user.must_change_password) return 'yellow'
  if (user.ldap_synced === true) return 'teal'
  return 'gray'
}
